var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 774,
    viewBox: "0 0 1440 774",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25987_49617)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25987_49617",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 774
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V773.965C1440 773.965 1003.75 774.043 720.5 773.965C438.023 773.888 0 773.965 0 773.965V0Z",
    fill: "#F4F1FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25987_49617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.234 -518.53C369.856 -543.091 399.998 -552.77 424.559 -540.149L1616.4 72.3241C1640.96 84.9457 1650.64 115.088 1638.02 139.649L1429.64 545.137C1417.02 569.696 1387.09 579.481 1362.53 566.863C1253.67 510.934 967.198 363.752 766.844 260.742C566.944 157.966 279.412 10.2363 170.282 -45.8305C145.717 -58.4507 136.241 -88.4903 148.864 -113.053L357.234 -518.53Z",
    fill: "#BCDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.31 218.47C1031.94 193.909 1062.08 184.23 1086.64 196.851L1693.83 508.878C1718.39 521.5 1728.07 551.642 1715.44 576.203L1481.81 1030.85C1469.19 1055.4 1439.08 1065.1 1414.52 1052.48C1345.22 1016.89 1209.19 947.003 1111.14 896.563C1013.29 846.23 876.787 776.104 807.298 740.41C782.73 727.791 773.068 697.655 785.692 673.089L1019.31 218.47Z",
    fill: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-411.504 366.47C-398.882 341.909 -368.74 332.23 -344.179 344.851L263.008 656.878C287.569 669.5 297.248 699.642 284.626 724.203L50.9906 1178.85C38.3713 1203.4 8.26449 1213.1 -16.2944 1200.48C-85.5959 1164.89 -221.624 1095 -319.68 1044.57C-417.53 994.23 -554.033 924.104 -623.522 888.41C-648.09 875.791 -657.752 845.655 -645.128 821.089L-411.504 366.47Z",
    fill: "#BCDDFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25987_49617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 774,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg-1.04d709b46215ac52404c8e57391a37ae.svg";
export { ForwardRef as ReactComponent };